// src/pages/SavedDraft.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './MySaveDraft.css';
// import { BASE_URL } from '../../utils/api';

// const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const SavedDraft = () => {
  const [draft, setDraft] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const saved = localStorage.getItem('questionDraft');
    if (saved) {
      setDraft(JSON.parse(saved));
    }
  }, []);

  const handleEditClick = () => {
    if (draft) {
      navigate('/dashboard/ask-question', { state: { draft } });
    }
  };

  if (!draft) {
    return <div className="saved-draft-container"><p>No saved draft found.</p></div>;
  }

  return (
    <div className="saved-draft-container">
      <h2>My Saved Draft</h2>
      {/* Make the title clickable */}
      <h3 className="clickable-title" onClick={handleEditClick}>
        {draft.title}
      </h3>
      <p><strong>Category:</strong> {draft.category}</p>
      <p><strong>Tags:</strong> {draft.tags}</p>
      <div dangerouslySetInnerHTML={{ __html: draft.details }}></div>
      {draft.image && <img src={draft.image} alt="Uploaded" style={{ maxWidth: '100%' }} />}
    </div>
  );
};

export default SavedDraft;
